<template>
    <div class="form">
        <!-- Country -->
        <div class="form__section" v-if="showCountryFilter">
            <div class="form__title">Nach Land filtern</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrSelect 
                        :hasGroups="true"
                        :options="countryOptions" 
                        :value="data.country" 
                        :multiple="true" 
                        placeholder="Wählen Sie die Länder, deren Warnungen angezeigt werden sollen" 
                        @change="fieldChangeHandler($event, 'country')"
                    />
                </div>
            </div>
        </div>
         <!-- Legend -->
        <div class="form__section">
            <div class="form__title">Legende Reise-Radar</div>
            <TravelRadarLegend />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import messageBoxBlueprint from '@/mixins/message-box-blueprint.js';
import SmrSelect from '@/components/form/SmrSelect.vue'
import TravelRadarLegend from '@/components/TravelRadarLegend.vue';

export default {
    components: {
        SmrSelect,
        TravelRadarLegend,
    },
    mixins: [
        settingsTabBlueprint,
        messageBoxBlueprint
    ],
    data() {
        return {
            data: {},
            showCountryFilter: false,
            countryOptions: [
                {
                    title: 'Beliebte Reiseziele',
                    options: [
                        { label: 'Ägypten', value: 'EG' },
                        { label: 'Deutschland', value: 'DE' },
                        { label: 'Frankreich', value: 'FR' },
                        { label: 'Griechenland', value: 'GR' },
                        { label: 'Italien', value: 'IT' },
                        { label: 'Kroatien', value: 'HR' },
                        { label: 'Spanien', value: 'ES' },
                        { label: 'Türkei', value: 'TR' },
                    ]
                },
                {
                    title: 'Weitere Länder',
                    options: [
                        { label: 'Albanien', value: 'AL' },
                        { label: 'Großbritannien', value: 'UK' },
                        { label: 'Nepal', value: 'NP' },
                        { label: 'Österreich', value: 'AT' },
                        { label: 'Polen', value: 'PL' },
                        { label: 'Portugal', value: 'PT' },
                        { label: 'Russland', value: 'RU' },
                        { label: 'Schweiz', value: 'CH' },
                        { label: 'Tschad', value: 'TS' },
                        { label: 'USA', value: 'US' },
                    ]
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['user']),
    },
    methods: {
        // async loadCountryList() {
        //     try {

        //     } catch(error) {
        //         console.error(error)
        //     }
        // }
    },
}
</script>
